import 'slick-carousel';
import { fireViewPromotion, fireSelectPromotion } from '../custom/event/ga4-events';

// Derive inert from .slick-active, NOT aria-hidden. slick's postSlide() fires
// `afterChange` BEFORE it calls initADA(), which is what rewrites aria-hidden
// (slick.js: trigger at 1691, initADA at ~1705, aria-hidden writes at 2298/2316).
// Reading aria-hidden from an afterChange handler therefore sees the PREVIOUS
// page's values, so the slides paging INTO view get stamped inert; initADA then
// flips their aria-hidden to "false" but never clears inert. The result is a slide
// that paints normally yet is dropped from hit-testing entirely — visible cards
// that cannot be clicked, with the click landing on .slick-track instead.
// setSlideClasses() sets .slick-active before the transition (slick.js:2550), so
// it is always current here and the sync is order-independent.
function syncInertSlides($carousel) {
    $carousel.find('.slick-slide').each(function () {
        const $slide = $(this);
        if ($slide.hasClass('slick-active')) {
            $slide.removeAttr('inert');
        } else {
            $slide.attr('inert', '');
        }
    });
}

/**
 * Build a GA4 promotion object from a hero carousel slide element.
 * Reads data-promo-id and data-promo-name attributes set in carousel.html.
 */
function getPromoFromSlide($slide) {
    const el = $slide.is('.heroCarousel-slide') ? $slide : $slide.find('.heroCarousel-slide');
    if (!el.length) return null;
    return {
        promotion_id:   el.data('promo-id') || '',
        promotion_name: el.data('promo-name') || '',
        creative_name:  'hero_carousel',
        creative_slot:  'homepage_hero',
    };
}

export default function () {
    const $carousel = $('[data-slick]');

    if ($carousel.length) {
        const multipleSlides = $carousel[0].childElementCount > 1;
        $carousel.slick({ dots: multipleSlides });

        // Fix: prevent focusable descendants inside aria-hidden slides
        $carousel.each(function () {
            syncInertSlides($(this));
        });

        $carousel.on('afterChange', function () {
            syncInertSlides($(this));
        });

        $carousel.on('destroy', function () {
            $(this).children().removeAttr('inert');
        });

        $(window).resize(() => {
            $carousel.not('.slick-initialized').slick('resize');
        });

        // GA4 promotion tracking for hero carousel
        const $heroCarousel = $('.heroCarousel[data-slick]');
        if ($heroCarousel.length) {
            // Defer hero autoplay until the first genuine user interaction so the banner
            // doesn't start rotating while the visitor is still taking in the page. Mirrors
            // the storefront first-interaction loaders (see the reviews.io snippet in
            // local-scripts.html); 'scroll' is intentionally excluded — a programmatic
            // scroll-into-view fires a trusted scroll with no real intent.
            $heroCarousel.slick('slickPause');
            const heroInteractionEvents = ['wheel', 'mousemove', 'pointerdown', 'touchstart', 'keydown', 'click'];
            const startHeroAutoplay = () => {
                heroInteractionEvents.forEach(e => window.removeEventListener(e, startHeroAutoplay));
                $heroCarousel.slick('slickPlay');
            };
            heroInteractionEvents.forEach(e => window.addEventListener(e, startHeroAutoplay, { passive: true }));

            // Fire view_promotion for the initial visible slide
            const $initialSlide = $heroCarousel.find('.slick-slide.slick-active');
            const initialPromo = getPromoFromSlide($initialSlide);
            if (initialPromo && initialPromo.promotion_id) {
                //fireViewPromotion([initialPromo]);
            }

            // Fire view_promotion on slide change
            $heroCarousel.on('afterChange', function (_event, _slick, currentSlide) {
                const $activeSlide = $(this).find(`.slick-slide[data-slick-index="${currentSlide}"]`);
                const promo = getPromoFromSlide($activeSlide);
                if (promo && promo.promotion_id) {
                    //fireViewPromotion([promo]);
                }
            });

            // Fire select_promotion on slide click
            $heroCarousel.on('click', '.heroCarousel-slide', function () {
                const promo = getPromoFromSlide($(this));
                if (promo && promo.promotion_id) {
                    //fireSelectPromotion(promo);
                }
            });
        }
    }

    // Alternative image styling for IE, which doesn't support objectfit
    if (typeof document.documentElement.style.objectFit === 'undefined') {
        $('.heroCarousel-slide').each((index, element) => {
            const $container = $(element);
            const imgUrl = $container.find('img').data('lazy');

            if (imgUrl) {
                $container.css('backgroundImage', `url(${imgUrl})`).addClass('compat-object-fit');
            }
        });
    }
}
